<template>
    <div>
        <input :value="data"
               type="number"
               ref="input"/>
    </div>
</template>

<script>
	export default {
		name: "NumericInput",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return parseInt(this.$refs.input.value);
			}
		}
	}
</script>

<style scoped>
    input {
        width: 100%;
        max-width: 600px;
    }
</style>